// extracted by mini-css-extract-plugin
module.exports = {"icon":"SearchSelectGroup_icon__3cazX","icon-reverse":"SearchSelectGroup_icon-reverse__1TsNh"};